module.exports = __webpack_public_path__ + "img/Chatapp3.4659e70f.jpg";